// Auto-generated by scripts/prefetch-marketing-pages.mjs — DO NOT EDIT
// Generated at: 2026-07-22T10:51:35.534Z
import { Routes } from '@angular/router';

export const COMPARISON_PAGE_SLUGS = ["topfan-vs-circle","topfan-vs-fanfix","topfan-vs-gumroad","topfan-vs-kajabi","topfan-vs-mighty","topfan-vs-passes","topfan-vs-patreon","topfan-vs-substack","topfan-vs-uscreen"] as const;

export const COMPARISON_PAGE_ROUTES: Routes = [
  {
    path: 'topfan-vs-circle',
    loadChildren: () =>
      import('../modules/comparison-page/comparison-page.module').then(
        (m) => m.ComparisonPageModule
      ),
    data: { comparisonSlug: 'topfan-vs-circle' }
  },
  {
    path: 'topfan-vs-fanfix',
    loadChildren: () =>
      import('../modules/comparison-page/comparison-page.module').then(
        (m) => m.ComparisonPageModule
      ),
    data: { comparisonSlug: 'topfan-vs-fanfix' }
  },
  {
    path: 'topfan-vs-gumroad',
    loadChildren: () =>
      import('../modules/comparison-page/comparison-page.module').then(
        (m) => m.ComparisonPageModule
      ),
    data: { comparisonSlug: 'topfan-vs-gumroad' }
  },
  {
    path: 'topfan-vs-kajabi',
    loadChildren: () =>
      import('../modules/comparison-page/comparison-page.module').then(
        (m) => m.ComparisonPageModule
      ),
    data: { comparisonSlug: 'topfan-vs-kajabi' }
  },
  {
    path: 'topfan-vs-mighty',
    loadChildren: () =>
      import('../modules/comparison-page/comparison-page.module').then(
        (m) => m.ComparisonPageModule
      ),
    data: { comparisonSlug: 'topfan-vs-mighty' }
  },
  {
    path: 'topfan-vs-passes',
    loadChildren: () =>
      import('../modules/comparison-page/comparison-page.module').then(
        (m) => m.ComparisonPageModule
      ),
    data: { comparisonSlug: 'topfan-vs-passes' }
  },
  {
    path: 'topfan-vs-patreon',
    loadChildren: () =>
      import('../modules/comparison-page/comparison-page.module').then(
        (m) => m.ComparisonPageModule
      ),
    data: { comparisonSlug: 'topfan-vs-patreon' }
  },
  {
    path: 'topfan-vs-substack',
    loadChildren: () =>
      import('../modules/comparison-page/comparison-page.module').then(
        (m) => m.ComparisonPageModule
      ),
    data: { comparisonSlug: 'topfan-vs-substack' }
  },
  {
    path: 'topfan-vs-uscreen',
    loadChildren: () =>
      import('../modules/comparison-page/comparison-page.module').then(
        (m) => m.ComparisonPageModule
      ),
    data: { comparisonSlug: 'topfan-vs-uscreen' }
  }
];
